import { MARKDOWN_FIELD_HEADING_PROSE } from '@/lib/markdown-field-typography'

/** Tailwind Typography for read-only field markdown (profile bio, org about, job description). */
export const MARKDOWN_PROSE = [
  'prose dark:prose-invert w-full !max-w-none text-base',
  MARKDOWN_FIELD_HEADING_PROSE,
  'prose-p:my-0 prose-p:py-1 prose-p:text-base prose-p:leading-relaxed prose-p:text-foreground',
  'prose-ul:my-2 prose-ul:list-disc prose-ul:pl-6',
  'prose-ol:my-2 prose-ol:list-decimal prose-ol:pl-6',
  'prose-li:my-0 prose-li:text-base',
  'prose-blockquote:my-1 prose-blockquote:border-l-2 prose-blockquote:pl-6 prose-blockquote:italic',
  'prose-code:rounded-md prose-code:bg-muted prose-code:px-[0.3em] prose-code:py-[0.2em] prose-code:font-mono prose-code:text-sm',
  'prose-a:font-medium prose-a:text-primary prose-a:underline hover:prose-a:text-primary/80',
  'prose-strong:font-bold',
  'prose-img:rounded-md prose-hr:my-4',
].join(' ')
